import zip from 'lodash/zip';
import head from 'lodash/head';
import sortBy from 'lodash/sortBy';
import jStat from 'jstat';
import { round5 } from 'utilities/math';

const getNormInv = value => value.map(el => round5(jStat.normal.inv(el, 0, 1)));

export const getDotsForProbabilityPlot = firstParsedParameterValues => {
  const n = firstParsedParameterValues.length;
  firstParsedParameterValues.sort((a, b) => a - b);
  const proportion = firstParsedParameterValues.map((_, i) => (i + 0.5) / n);

  return sortBy(
    zip(
      getNormInv(proportion),
      firstParsedParameterValues
    ),
    head
  );
};
